<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ order_header.order_code }}</b></div>
            <div v-if="order_header.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
            <div v-if="order_header.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #fdac39">กำลังดำเนินการ</b></div>
            <div v-if="order_header.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #86bc3a">สำเร็จ</b></div>
            <div v-if="order_header.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: red">ยกเลิกคำสั่งซื้อ</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลพาร์ทเนอร์</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อพาร์ทเนอร์ : </div>
              <div class="ml-1 mr-3">{{ order_header.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_header.telephone !== null" class="ml-1 mr-3">{{ order_header.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การตอบกลับจากฟาร์มาแคร์พลัส</b></div>
                <div v-if="order_header.status === 0" class="mt-3">
                  <div class="ml-1 mr-3">ยังไม่มีการตอบกลับ</div>
                </div>
              </div>
              <div class="mt-2 display_mobile">
                <v-btn elevation="5" @click="image_modal = true"
                  class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-form ref="form_due" @submit.prevent="create_partner_due">
            <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
              <div class="pa-5">
                <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
                <v-divider />
                <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage"
                  hide-default-footer mobile-breakpoint="0">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td class="border_table">
                        <div class="mx-auto">
                          <v-img class="mx-auto rounded" height="120" width="120" max-width="120"
                            v-if="dataDetail.item.product_picture !== null" :lazy-src="picture_product"
                            :src="dataDetail.item.product_picture"></v-img>
                          <v-img class="mx-auto rounded" height="120" width="120" max-width="120" v-else
                            :lazy-src="picture_product" :src="picture_product"></v-img>
                        </div>
                      </td>
                      <td class="border_table pa-3">
                        <div>{{ dataDetail.item.product_name }}<br>
                          <b :class="{ '': parseInt(dataDetail.item.count_warehouse) >= dataDetail.item.qty_unit, 'error--text': dataDetail.item.count_warehouse < dataDetail.item.qty_unit }"
                            v-if="dataDetail.item.count_in_warehouse">จำนวนคงเหลือในคลัง :
                            {{ dataDetail.item.count_in_warehouse }}</b>
                        </div>
                        <div v-if="dataDetail.item.product_list !== null">
                          <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                            <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                            <br>
                            <small class="pl-5 primary--text" v-if="data.count_in_warehouse"><b>จำนวนคงเหลือในคลัง : {{
                              data.count_in_warehouse }}</b></small>
                          </div>
                        </div>
                      </td>
                      <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                      <td class="border_table text-center">
                        <div class="mt-3 pa-2 d-flex v-input__slot">
                          <v-text-field type="number" min="0" pattern="[0-9]*"
                            @input="checkMax_value(dataDetail.item.id, dataDetail.item.qty)"
                            @keypress="isOnlyNumber($event)" v-model="dataDetail.item.qty" color="#8cc63e" label="จำนวน"
                            :rules="[v => !!v || 'กรุณากรอกจำนวน']" hide-details="auto" required outlined></v-text-field>
                          <div v-if="dataDetail.item.type != 1" class="pt-3 pl-3">{{ dataDetail.item.unit_name }}</div>
                          <v-select v-else class="ml-2" :items="dataDetail.item.unit_list" item-text="name"
                            item-value="unit_id" v-model="dataDetail.item.unit_id"
                            @change="changeUnit(dataDetail.item.unit_list, dataDetail.item.unit_id, dataDetail.index)"
                            color="#8cc63e" label="หน่วยนับ" hide-details="auto" outlined></v-select>
                        </div>
                      </td>
                      <!-- <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td> -->
                      <td class="border_table text-center">{{ format_price(dataDetail.item.cost * dataDetail.item.qty) }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append>
                    <tr>
                      <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                      <td class="border_table text-center">
                        <div v-if="order_header.delivery_type === 3"><b>{{ result_weight }}</b></div>
                        <div v-else><b>0.00</b></div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                      <td v-if="order_header.delivery_type === 3" class="border_table text-center"><b>{{ result_total =
                      format_price(total + parseFloat(result_weight)) }}</b></td>
                      <td v-else class="border_table text-center"><b>{{ result_total = format_price(total) }}</b></td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card>
            <div class="text-center pa-5 mb-3">
              <v-btn large elevation="5" type="submit" style="font-size: 18px"
                class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
                เสนอดิลใหม่ให้ลูกค้า
              </v-btn>
            </div>
          </v-form>
        </div>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_number(100.32) }} บาท </div>
                </div>
                <div class="pa-6">
                  <!--                  <v-img v-if="slip_img.slip_picture !== null" class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="slip_img.slip_picture"></v-img>-->
                  <!--                  <v-img v-else class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>-->
                  <v-img class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder"
                    :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail(0)"
                    class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct"
                    class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_product from "@/assets/pill.png";
import { HTTP } from "@/axios";
import { formatNumber, formatPrice, onlyForNumber } from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_partner_edit",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_product: picture_product,
      perPage: -1,
      image_modal: false,
      overlay: false,
      weight_all: 0,
      result_weight: 0,
      result_total: 0,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      weight_list: [],
      order_header: [],
      slip_img: [],
    }
  },
  methods: {
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('wholesales/orderdetail/newdeal', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_header = res.data.order_head
          this.data_list = res.data.order_list
          this.data_list.forEach((item, index) => {
            this.data_list[index].set_quantity = item.qty
            this.data_list[index].new_set_quantity = item.qty
          })
          res.data.order_list.forEach((data) => {
            this.weight_all += data.qty * parseFloat(data.weight)
          })
          this.get_price_rate(this.weight_all)
          // this.slip_img = res.data.object.slip_picture[0]
        }
      })
    },
    async changeUnit(unit_list, unit_id, index) {
      const unitList = unit_list.find((detail) => detail.unit_id == unit_id)
      this.data_list[index].qty = this.data_list[index].set_quantity
      this.data_list[index].cost = unitList.cost
      this.data_list[index].qty = Math.floor(this.data_list[index].qty / unitList.qty)
      this.data_list[index].new_set_quantity = this.data_list[index].qty
    },
    async get_price_rate(weight) {
      // let get_weight = this.format_price(weight)
      // let math_weight = Math.ceil(get_weight)
      let math_weight = this.format_price(weight)
      let weight_arr = []
      await HTTP.get('wholesales/price_rate')
        .then((res) => {
          if (res.data.success === true) {
            res.data.price_rate.forEach((data) => {
              weight_arr.push({
                id: data.id,
                rate_end: data.rate_end !== null ? data.rate_end : '0.00',
                rate_price: data.rate_price,
                rate_start: data.rate_start !== null ? data.rate_start : '0.00',
                rate_type: data.rate_type,
              })
            })
            this.weight_list = weight_arr
            // let result_weight = weight_arr.find((data) => (math_weight >= parseFloat(data.rate_start)))
            let result_weight = null
            weight_arr.forEach((data) => {
              if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
                result_weight = data
                return
              } else if (data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)) {
                result_weight = data
                return
              } else if (data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)) {
                result_weight = data
                return
              }
            })
            this.result_weight = result_weight.rate_price
          }
        })
    },
    checkMax_value(id, quantity) {
      // let math_weight = Math.ceil(this.weight_cal)
      let math_weight = this.format_price(this.weight_cal)
      let old_result_weight = this.result_weight
      this.data_list.forEach((item) => {
        if (item.id === id) {
          if (math_weight !== 0) {
            // let result_weight = this.weight_list.find((data) => (math_weight >= parseFloat(data.rate_start)))
            let result_weight = null
            this.weight_list.forEach((data) => {
              if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
                result_weight = data
                return
              } else if (data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)) {
                result_weight = data
                return
              } else if (data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)) {
                result_weight = data
                return
              }
            })
            this.result_weight = result_weight.rate_price
          }
          else {
            this.result_weight = 0
          }

          if (item.type == 1) {
            const unitDetail = item.unit_list.find((detail) => detail.unit_id == item.unit_id)
            let qtyUnit = unitDetail.qty * parseInt(quantity)
            if (quantity < 0 || (quantity === 'NaN' || quantity === '')) {
              item.qty = item.new_set_quantity
            } else {
              if (qtyUnit > item.qty_unit) {
                Swal.fire({
                  text: 'จำนวนที่กรอกต้องไม่เกินจำนวนปัจจุบัน !',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  item.qty = item.new_set_quantity
                  this.result_weight = old_result_weight
                })
              }
            }
          } else {
            if (quantity < 0 || (quantity === 'NaN' || quantity === '')) {
              item.qty = item.set_quantity
            } else {
              if (parseInt(quantity) > item.set_quantity) {
                Swal.fire({
                  text: 'จำนวนที่กรอกต้องไม่เกินจำนวนปัจจุบัน !',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  item.qty = item.set_quantity
                  this.result_weight = old_result_weight
                })
              }
            }
          }

        }
      })
    },
    create_partner_due() {
      let id_arr = []
      let quantity_arr = []
      let qty_arr = []
      let unit_id_arr = []
      let cost_arr = []
      this.data_list.forEach((item) => {
        id_arr.push(item.id)
        qty_arr.push(item.qty)
        quantity_arr.push(item.set_quantity)
        unit_id_arr.push(item.unit_id)
        cost_arr.push(item.cost)
      })
      if (this.$refs.form_due.validate()) {
        Swal.fire({
          title: 'ต้องการดำเนินการต่อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('wholesales/orderedit', {
              order_wholesale_id: this.$route.params.id,
              id: id_arr,
              quantity: quantity_arr,
              qty_new: qty_arr,
              unit_id_new: unit_id_arr,
              cost: cost_arr,
              user_id: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              delivery_price: this.result_weight,
              total_price: this.result_total,
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.save_data_calculate_product()
                this.$router.push('/sell/orderpartnerdetail/' + this.$route.params.id)
              }
            })
          }
        })
      }
    },
    
    async save_data_calculate_product() {
      this.overlay = false
      await HTTP.get('wholesales/cal-cost-product/' + this.$route.params.id).then((res) => {
        console.log(res.data);
      })
    },

  },
  computed: {
    weight_cal() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_weight = number.qty * parseFloat(number.weight)
        if (total_weight < 0) {
          return sum + (0)
        }
        else {
          return sum + (total_weight);
        }
      }, 0)
      return result;
    },
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum + (0)
        }
        else {
          return sum + (total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}

.rounded_card {
  border-radius: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.grid_img {
  display: grid;
  grid-template-columns: 70% 30%;
}

.border_table {
  border: #e0e0e0 solid 1px
}

.mobile_btn {
  width: 50%;
}

.display_pc {
  display: block;
}

.display_mobile {
  display: none;
}

.mobile_grid {
  width: 25%
}

.v-input__slot>>>input {
  text-align: center !important;
}

@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_grid {
    width: 32%
  }
}

@media only screen and (max-width: 500px) {
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }

  .grid_mx {
    margin: auto;
  }

  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_btn {
    width: 100%;
  }

  .display_pc {
    display: none;
  }

  .display_mobile {
    display: block;
  }
}</style>
